<script lang="ts">
  import DistributorsPage from "@shared/svelte/Components/Distributors/Page.svelte";
  import Spinner from "@shared/svelte/Components/SpinnerInternal.svelte";
  import DistributorsStore from "@shared/svelte/Stores/DistributorsStore";
  import { HttpPromise } from "@shared/svelte/Modules/ApiService";
  import * as _ from "lodash";

  const distributorsSearchRes = async () => {
    try {
      let res = await HttpPromise({
        method: "GET",
        url: "/api/retailer/distributors/search",
      });
      return res;
    } catch (e) {
      return [];
    }
  };

  const distributorsRes = async () => {
    let res = [];
    res = await HttpPromise({
      method: "GET",
      url: "/api/retailer/distributors",
      data: {
        with_cutoff_time: true,
        with_integrated: true,
        with_sales_reps: true,
        with_domains: true,
      },
    }).catch(() => (res = []));
    DistributorsStore.set(res);
    return res;
  };

  const load = async () => {
    const promises = [distributorsRes(), distributorsSearchRes()];

    let results = await Promise.all(promises);

    return {
      distributors: results[0],
      distributorsSearch: results[1],
    };
  };

</script>

{#await load()}
  <Spinner />
{:then data}
  <DistributorsPage allDistributors={data.distributorsSearch} />
{/await}
